module.exports = __webpack_public_path__ + "media/src/images/certificates/certificate_frame-4b5613fa8bcf8653e4bcebc580a63d89.png";